module.exports = __webpack_public_path__ + "static/media/12-seo.458ab3b5.png";